export const defaultTheme = {
    colorBlack: "#070707",
    colorGray: "#828282",
    defaultGilroyFontFamilyBold: '"Gilroy-Bold",  sans-serif',
    gilroyFontFamilyMedium: ' "Gilroy-Medium", sans-serif',
    fontSizeDefault: "18px",
    fontSizeTitle: "34px",
    colorGrayBackground: "#f6f6f6",
    colorWhite: "#ffffff",
    paddingDefault :"48px 0 40px",
    paddingMobile :"48px 0 40px",
  };
  